import AILogService from '../../services/AILogService'

const state = () => ({
    loadingAILog: false,
    ai_logs: [],
    total: 0,
    pages: 0,
    page: 1,
    show_modal_filter_ailog: false,
    filters_ailog: [
        {
            id: 'action',
            name: 'Ação',
            type: 'select',
            isOpen: false,
            options: [
                { value: 'CREATE', label: 'Criar', checked: false },
                { value: 'UPDATE', label: 'Atualizar', checked: false },
                { value: 'DELETE', label: 'Deletar', checked: false },
                { value: 'SELECT', label: 'Consultar', checked: false }
            ],
        },
        {
            id: 'model',
            name: 'Modelo',
            type: 'select',
            isOpen: false,
            options: [
                { value: 'User', label: 'Usuário', checked: false },
                { value: 'Category', label: 'Categoria', checked: false },
                { value: 'Course', label: 'Curso', checked: false },
                { value: 'Aula', label: 'Aula', checked: false }
            ],
        }
    ],
})

const mutations = {
    SET_AI_LOGS: (state, payload) => {
        if(payload.pageNumber == 1) {
            state.ai_logs = payload.itens
        } else {
            state.ai_logs = [...state.ai_logs, ...payload.itens]
        }
        state.page = payload.pageNumber
        state.pages = payload.pages
        state.total = payload.total
    },
    SET_LOADING_AILOG: (state, payload) => {
        state.loadingAILog = payload
    },
    SET_SHOW_MODAL_FILTER_AILOG: (state, boolean) => {
        state.show_modal_filter_ailog = boolean
    },
    TOGGLE_FILTER_AILOG_OPTION(state, { filterId, optionValue }) {
        const filter = state.filters_ailog.find(f => f.id === filterId);
        if (filter) {
            const option = filter.options.find(o => o.value === optionValue);
            if (option) {
                option.checked = !option.checked;
            }
        }
    },
}

const actions = {
    async fetchAILogs({commit, state}, { keyword = '', pageNumber = 1, order = { name: 'ID', column: 'id', sort: 'DESC' } }) {
        try{
            commit('SET_LOADING_AILOG', true)
            let filters = state.filters_ailog.reduce((acc, filter) => {
                acc[filter.id] = filter.options.filter(option => option.checked).map(option => option.value);
                return acc;
            }, {});
            const response = await AILogService.get(keyword, pageNumber, filters, order);
            commit('SET_AI_LOGS', response.data)
            commit('SET_LOADING_AILOG', false)
        } catch (error) {
            commit('SET_LOADING_AILOG', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async exportAILogs({ state }, { keyword = '', order = { name: 'ID', column: 'id', sort: 'DESC' } }) {
        try {
            let filters = state.filters_ailog.reduce((acc, filter) => {
                acc[filter.id] = filter.options.filter(option => option.checked).map(option => option.value);
                return acc;
            }, {});

            const response = await AILogService.export(keyword, filters, order);

            const date = new Date().toISOString().slice(0, 10);
            const fileName = `Relatorio_AILogs_${date}.csv`;
            const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Erro ao exportar AI Logs:', error);
        }
    },
    async rollbackAILog({commit}, id) {
        try {
            commit('SET_LOADING_AILOG', true)
            const response = await AILogService.rollback(id);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            commit('SET_LOADING_AILOG', false)
        } catch (error) {
            commit('SET_LOADING_AILOG', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    toggleFilterAILogOption({ commit, dispatch }, payload) {
        commit('TOGGLE_FILTER_AILOG_OPTION', payload);
        dispatch('fetchAILogs', {keyword: "", pageNumber: 1})
    },
}

const getters = {
    getAILogs: state => state.ai_logs,
    getLoadingAILog: state => state.loadingAILog,
    getShowModalFilterAILog: state => state.show_modal_filter_ailog,
    getFiltersAILog: state => state.filters_ailog
}

export default {
    state,
    getters,
    mutations,
    actions
};